import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/train-order-detail',
      name: 'admin-train-order-detail',
      component: () => import(/* webpackChunkName: "page-admin-train-order--management-train-order-detail" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "订单详情"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "火车票订单管理"
                                        },
                                        {
                                                  name: "订单列表"
                                        },
                                        {
                                                  name: "订单详情"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
